import React, { ReactElement } from 'react';
import { cn } from 'src/domains/common/components/utils';
import { POPUP_RISK_LEVEL_OPTIONS, PopupRiskLevelType } from './MarkersOfHarmPopupTab.types';

type MarkersOfHarmRiskLevelFieldPropsType = {
    value: PopupRiskLevelType;
    onChange: (value: PopupRiskLevelType) => void;
    dataTest?: string;
};

export const MarkersOfHarmRiskLevelField = ({
    value,
    onChange,
    dataTest,
}: MarkersOfHarmRiskLevelFieldPropsType): ReactElement => (
    <div
        className='flex flex-col gap-3 sm:flex-row'
        data-test={dataTest}
    >
        {POPUP_RISK_LEVEL_OPTIONS.map((option) => {
            const isSelected = value === option.value;

            return (
                <label
                    key={option.value}
                    className={cn(
                        'flex flex-1 cursor-pointer items-center gap-2 rounded-md border border-solid px-4 py-3 transition-colors',
                        isSelected ? 'border-primary' : 'border-input'
                    )}
                    data-test={`markers-of-harm-popup-risk-level-${option.value}`}
                    data-test-selected={isSelected ? true : undefined}
                >
                    <input
                        type='radio'
                        className='sr-only'
                        name='markers-of-harm-popup-risk-level'
                        value={option.value}
                        checked={isSelected}
                        onChange={(): void => {
                            onChange(option.value);
                        }}
                    />
                    <span
                        className={cn(
                            'flex size-4 shrink-0 items-center justify-center rounded-full border border-solid border-primary'
                        )}
                    >
                        {isSelected ? <span className='size-2 rounded-full bg-primary' /> : null}
                    </span>
                    <span className='text-sm text-foreground'>{option.label}</span>
                </label>
            );
        })}
    </div>
);
